import React from "react";
import "./Contacgrats_lottie.css"
import Lottie from "lottie-react";
import congratsAnimation from "./Contacgrats_lottie.json";

function Contacgrats_lottie() {
    return (
        <div className="Contacgrats_lottie_holder">
            <Lottie animationData={congratsAnimation} loop={true} className="Contacgrats_lottie"/>
        </div>
    );
}

export default Contacgrats_lottie;
